import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import { Container } from '@styles/helpers'
import { tablet } from '@styles/mixins'
import React from 'react'
import { useLocation } from 'react-router'
import styled, { css } from 'styled-components'

export default function NotFound() {
    const location = useLocation<{ from?: Location }>()

    return (
        <NotFoundContainer>
            <Grid gap="15px">
                <Grid gap="10px">
                    <h1 className="h3">This page doesn't exist.</h1>
                    {location.state?.from && <p>You tried to find {location.state.from.pathname}, but we don't have it on our website.</p>}
                </Grid>
                <Button type="tertiary" scheme="outline" to="/">Return to the main page</Button>
            </Grid>
        </NotFoundContainer>
    )
}

// STYLES
const NotFoundContainer = styled(Container)`
    padding-top: 30px;
    padding-bottom: 30px;
    max-width: 800px;
    margin: 0 auto 0 0;

    ${tablet(css`
        padding-top: 60px;
        padding-bottom: 60px;
    `)}
`